import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const SummaryBlock = ({ heading, children, className, infoText }) => {
  return (
    <div className={classNames("summary-block", className)}>
      <div className="block-grid">
        <div className="menu-caps">{heading}</div>
        <div className="block-content">{children}</div>
      </div>
      {infoText && <div className="caption gray">{infoText}</div>}
    </div>
  );
};

SummaryBlock.propTypes = {
  heading: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  infoText: PropTypes.string,
};

export default SummaryBlock;
